// Fonctions utilitaires pour l'éditeur
export const extractOutline = (content) => {
  if (!content) return [];
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  const headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");
  
  return Array.from(headings).map((heading, index) => ({
    id: index,
    level: parseInt(heading.tagName[1]),
    text: heading.textContent.trim(),
    tag: heading.tagName.toLowerCase(),
  }));
};

export const updateDocumentStats = (content) => {
  if (!content) {
    return { wordCount: 0, charCount: 0 };
  }

  const textOnly = content.replace(/<[^>]+>/g, " ");
  const words = textOnly.trim().split(/\s+/).filter(Boolean);
  
  return {
    wordCount: words.length,
    charCount: textOnly.replace(/\s/g, "").length
  };
};

export const getCurrentDateTime = () => {
  return new Date().toISOString().slice(0, 19).replace('T', ' ');
};